import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useAnalytics } from 'contexts/AnalyticsContext';
import { ANALYTICS_EVENTS } from 'constants/analyticsEvents';
import { CardTypeOptions } from 'constants/graphqlTypes';
import { useGuestListHeader } from 'graphQL/guestList/hooks';
import { useContentNotFound } from 'helpers/routingHelper';

import useTheme from 'helpers/useTheme';
import Header from 'components/GuestList/Header';
import SeriesSelect from 'components/GuestList/SeriesSelect/SeriesSelect';
import SeriesList from 'components/GuestList/SeriesList/SeriesList';
import Wrap from 'components/UI/Wrap';

const GuestListSeries: FC = () => {
  const { track } = useAnalytics();

  const { id } = useParams<{ id: string }>();
  const { card, loading } = useGuestListHeader(id, CardTypeOptions.GuestListSeries);
  const { guestListSeries } = card ?? {};

  const handlerContentNotFound = useContentNotFound();
  const isDark = useTheme();

  if (!guestListSeries && !loading) {
    handlerContentNotFound();
  }

  useEffect(() => {
    track(ANALYTICS_EVENTS.GuestListAction);
    track(ANALYTICS_EVENTS.GuestListSeriesOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {card && <Header card={card} isDark={isDark} isSeries />}
      {guestListSeries && (
        <Wrap paddingTop={0}>
          <SeriesSelect isDark={isDark} current={guestListSeries} />
          <SeriesList isDark={isDark} series={guestListSeries} />
        </Wrap>
      )}
    </>
  );
};

export default GuestListSeries;
